import * as Yup from 'yup';

import { type TValidationConfig } from '../types/configs';

import { getObjectValidation, getStringValidation } from './validations';

const getBeneficiarySchema = (operation?: string, validationConfig?: TValidationConfig) =>
  Yup.object().shape({
    code: getObjectValidation({ field: 'beneficiary.code', operation }),
    phoneNumber: getStringValidation({ field: 'beneficiary.phoneNumber', operation, validationConfig }),
    email: getStringValidation({ field: 'beneficiary.email', email: true, operation, validationConfig }),
  });

export default getBeneficiarySchema;
